import { render, staticRenderFns } from "./TagsOverview.vue?vue&type=template&id=1211053c&scoped=true"
import script from "./TagsOverview.vue?vue&type=script&lang=js"
export * from "./TagsOverview.vue?vue&type=script&lang=js"
import style0 from "./TagsOverview.vue?vue&type=style&index=0&id=1211053c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1211053c",
  null
  
)

export default component.exports